<template>
    <b-form-group label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" la :label-cols-lg="labelColsLg" :label-cols-sm="labelColsSm">
        <template #label>
            {{ title }}:
            <div v-if="!!hint" class="atmo-help">
                &nbsp;<i class="atmo-icon-question-mark"></i><span class="atmo-help__text">{{ hint }}</span>
            </div>
        </template>
        <div class="d-flex justify-content-between">
            <p v-if="documents.length === 0" :class="!state ? 'text-danger' : ''" class="fs-14 col-form-label my-auto">Прикрепите документы</p>
            <p v-else>&nbsp;</p>
            <file-uploader class="float-right my-auto" @set_file="addFile">Загрузить</file-uploader>
        </div>
            <div v-for="(document, index) in documents" :key="index" class="d-flex justify-content-between">
                <a class="fs-14 col-form-label d-inline-block" :href="$getAttachmentDownloadLink(document.id)" target="_blank">{{ document.name }}</a>
                <action-button-small :disabled="isLoading" icon="trash" @click="removeFile(index, true)" />
            </div>
    </b-form-group>
</template>

<script>
export default {
    name: 'form-row-single-line-multiple-documents-upload',
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: Array,
            default: () => []
        },
        v: {
            type: Object,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        headerClass: {
            type: String,
            default: 'fs-32'
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            default: 6
        },
        labelColsSm: {
            default: 4
        },
        hint: {
            type: String,
            default: ''
        },
        withSend: {
            type: Boolean,
            default: false
        },
        sendTitle: {
            type: String,
            default: 'Отправить'
        }
    },
    data() {
        return {
            visible: []
        };
    },
    methods: {
        addFile(file) {
            this.documents.push(file);
            this.$emit('add', file);
        },
        removeFile(index) {
            this.$emit('remove', this.documents[index]);
            this.documents.splice(index, 1);
        }
    },
    computed: {
        documents: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        state() {
            return typeof this.v !== 'undefined' && this.v !== null ? !this.v.$invalid : null;
        }
    }
};
</script>

<style scoped>
.table-responsive {
    padding-left: 5px;
    padding-right: 5px;
}
.fix-pos {
    margin-left: 5px;
    margin-right: 5px;
}
.table {
    border-collapse: collapse;
    margin-bottom: 0;
}

.is-invalid {
    border: 1px solid red;
    border-radius: 2px;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 8px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 8px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}

a {
    color: var(--green-color) !important;
}
</style>
